import { all, fork } from "redux-saga/effects";

//auth
import authSaga from "./auth/saga";
import layoutSaga from "./layout/saga";
import myAccountSaga from "./My-Account/saga";
import dashboardSaga from "./dashboard/saga";
import packagesSaga from "./packages/saga";
import activitiesSaga from "./activities-list/saga";

export default function* rootSaga() {
  yield all([
    fork(authSaga),
    fork(layoutSaga),
    fork(myAccountSaga),
    fork(dashboardSaga),
    fork(activitiesSaga),
    fork(packagesSaga),
  ]);
}
